import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { PrivacyPolicy } from "./privacy-policy";
import { FooterAd } from "./ads";
import { useShowAds } from "../hooks";

export const Footer = () => {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const { showAds } = useShowAds();

  return (
    <>
      {showPrivacyPolicy && (
        <PrivacyPolicy
          show={showPrivacyPolicy}
          onClear={() => setShowPrivacyPolicy(false)}
        />
      )}
      <Row className="text-center">
        <Col>
          <hr />
          <p>
            This toy webapp is not affiliated with Interactive Brokers in any
            way. Market data provided by IEX.
          </p>
          <p>
            Nothing on this site should be in any way construed as a
            recommendation to buy or sell any security. Or do anything
            whatsoever.
          </p>
          <p>
            Still here? Great! If you like IBorrowDesk, don't want to see ads,
            and want a few perks there's now a{" "}
            <a href="https://www.patreon.com/iborrowdesk" target="_blank">
              Patreon
            </a>
            !
          </p>
          <div style={{ textAlign: "center" }}>
            <a
              style={{ cursor: "pointer" }}
              onClick={() => setShowPrivacyPolicy(true)}
            >
              Privacy Policy
            </a>
          </div>
          {showAds && <FooterAd />}
        </Col>
      </Row>
    </>
  );
};
